import React from "react";
import styles from "./GuestScreen2.module.css";
import { SubmitButton, TextComponent } from "../../../../components";
import { List } from "antd";
import { useSelector } from "react-redux";
const GuestScreen2 = ({ setCurrentStep }) => {
  const WeddingWeb = useSelector((state) => state.EventReducer.WeddingWeb);
  return (
    <div className={styles.mainCont}>
      <TextComponent text={"Love Starts Here!"} textClass={styles.heading} />
      <List
        dataSource={WeddingWeb?.stories?.length > 0 ? WeddingWeb?.stories : []}
        className={styles.list}
        renderItem={(item, index) => {
          return (
            <div className={styles.listItem} key={index}>
              <TextComponent text={item?.title} textClass={styles.question} />
              <TextComponent
                text={item?.description}
                textClass={styles.answer}
              />
            </div>
          );
        }}
      />
      <div className={styles.submitBtn}>
        <SubmitButton
          btnClass={styles.nextBtn2}
          title={"Next"}
          onClick={() => setCurrentStep((prev) => prev + 1)}
        />
      </div>
    </div>
  );
};

export default GuestScreen2;
